import {jwtDecode} from 'jwt-decode';

import {RolesAccount} from '@/app/auth';
import logError from '@/utils/errors/logError';

import {CTokenDecoded, ITokenDecodedUser} from './models';

export const decodeToken = (
  token: string,
  defaultRole: string = RolesAccount.PARENT,
): ITokenDecodedUser | null => {
  try {
    const tokenDecoded: any = jwtDecode(token);

    if (!tokenDecoded) return null;

    const userId = tokenDecoded[CTokenDecoded.CUSTOM_USER_UUID] ?? '';
    const role = tokenDecoded[CTokenDecoded.CUSTOM_ROLES] ?? defaultRole;

    return {
      ...tokenDecoded,
      user_uuid: userId,
      role: role,
    };
  } catch (error) {
    logError(error, {
      fileName: 'AuthenticationUtils',
      functionName: 'decodeToken',
    });
    return null;
  }
};
